import { render, staticRenderFns } from "./joinAssociation.vue?vue&type=template&id=03e65e4f&scoped=true"
import script from "./joinAssociation.vue?vue&type=script&lang=js"
export * from "./joinAssociation.vue?vue&type=script&lang=js"
import style0 from "./joinAssociation.vue?vue&type=style&index=0&id=03e65e4f&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03e65e4f",
  null
  
)

export default component.exports